module.exports = __webpack_public_path__ + "static/media/DELETEselectArrowDown.f7e29be7.svg";